import React from 'react';
import {useTranslation} from 'react-i18next';

import {theme} from '../constants';
import {useAppDispatch, useAppSelector} from '../store';
import {setLanguage} from '../store/slices/preferencesSlice';
import {AppLanguage, SUPPORTED_LANGUAGES} from '../i18n/config';

type Props = {
  containerStyle?: React.CSSProperties;
};

export const LanguageSwitcher: React.FC<Props> = ({containerStyle}) => {
  const dispatch = useAppDispatch();
  const selectedLanguage = useAppSelector((state) => state.preferencesSlice.language);
  const {t} = useTranslation();

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        backgroundColor: theme.colors.ghostWhite,
        border: `1px solid ${theme.colors.aliceBlue2}`,
        borderRadius: 8,
        padding: 3,
        gap: 2,
        ...containerStyle,
      }}
      aria-label={t('common.language')}
      role='group'
    >
      {SUPPORTED_LANGUAGES.map((language) => {
        const active = selectedLanguage === language;
        return (
          <button
            key={language}
            type='button'
            onClick={() => dispatch(setLanguage(language as AppLanguage))}
            aria-pressed={active}
            style={{
              borderRadius: 6,
              padding: '5px 9px',
              minWidth: 38,
              fontSize: 12,
              fontFamily: "'SS3', sans-serif",
              fontWeight: active ? 600 : 400,
              border: 'none',
              color: active ? theme.colors.white : theme.colors.bodyTextColor,
              backgroundColor: active ? theme.colors.mainDark : 'transparent',
            }}
          >
            {t(`languages.${language}`)}
          </button>
        );
      })}
    </div>
  );
};


